import { TIconSize, TSize } from '@src/models/common';

export const ICON_SIZE: { [x in TSize]: TIconSize } = {
  md: 'md-light',
  lg: 'md-light',
  sm: 'md-light',
};
